// This global is used by core to define the asset path during the core build
// we do this to allow core to ship disco-ui for a number of different envs.
// __webpack_public_path__ is a "special" global that is used as a prefix for
// file-loaded assets.
//
// This is in a separate file so that it can be imported at the top of the src/index.js
// entry point. This is necessary because ES6's module interop forces this to the top
// and putting it as a var above the imports de-hoists the variable. I am so sorry.
//
// https://github.com/webpack/webpack/issues/2776
//
// This solution was blessed by @sokra, so we're going with it until we switch to
// a new best terrible build tool.

/* eslint-disable */
// @ts-ignore
__webpack_public_path__ = DISCOVERY_ASSET_PATH;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/public-path.js